import { render, staticRenderFns } from "./CardTimeAnswer.vue?vue&type=template&id=bab80d8c&scoped=true&"
import script from "./CardTimeAnswer.vue?vue&type=script&lang=js&"
export * from "./CardTimeAnswer.vue?vue&type=script&lang=js&"
import style0 from "./CardTimeAnswer.vue?vue&type=style&index=0&id=bab80d8c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab80d8c",
  null
  
)

export default component.exports